( function( $ ) {
	var $review_content = $( '.js-review-content' );
	var review_button = '<button type="button" class="reviews__button">Read more...</button>';

	function expand_content() {
		$review_content.removeClass( 'reviews__overflow' );
		$( '.reviews__button' ).remove();

		$review_content.each( function() {
			var review_height = $( this ).height();

			if ( review_height > 120 ) {
				$( this ).addClass( 'reviews__overflow' );
				$( this ).after( review_button );
			}
		} );

		$( '.reviews__button' ).on( 'click', function() {
			$( this )
				.prev( $review_content )
				.toggleClass( 'reviews__overflow' );

			$( this ).toggleClass( 'expanded' );
			if ( $( this ).hasClass( 'expanded' ) ) {
				$( this ).html( 'Read less...' );
			} else {
				$( this ).html( 'Read more...' );
			}
		} );
	}

	expand_content();

	window.addEventListener( 'resize', function() {
		expand_content();
	} );
} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/partials/reviews.js